module.exports = __webpack_public_path__ + "static/media/stayplease-big.ef9158ce.png";